<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-10-14 16:36:38
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_DynamicForm.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-07 16:06:09
-->
<template>
  <v-col
    :xs="formStyle && formStyle.xs ? formStyle.xs : 12"
    :sm="formStyle && formStyle.sm ? formStyle.sm : 12"
    :md="formStyle && formStyle.md ? formStyle.md : 6"
    :lg="formStyle && formStyle.lg ? formStyle.lg : 6"
    :xl="formStyle && formStyle.xl ? formStyle.xl : 4"
    :cols="formStyle && formStyle.cols ? formStyle.cols : 12"
    v-if="
      !(
        data['custom_field_data_type'] == 'file' &&
        fileList.length <= 0 &&
        !iSEdited
      )
    "
  >
    <inputTextFiledMultiLang
      v-if="data && data['custom_field_data_type'] == 'multiLang'"
      :bindData="curvalue"
      maxlength="100"
      :readonly="!iSEdited"
      :filled="iSEdited"
      @change="
        (valueArr) => {
          curvalue = valueArr;
        }
      "
      :placeholder="$getCommonLangValue(data['custom_field_placeholder'])"
      :label="$getCommonLangValue(data['custom_field_name'])"
      :rules="
        Number(data.is_required) ? $GetRules(['_Require_Rules'], [null]) : []
      "
    />
    <template v-else-if="data && data['custom_field_data_type'] == 'text'">
      <v-sheet
        class="text--secondary"
        :class="Number(data.is_required) ? ' mrc_text_require ' : ''"
      >
        {{ $getCommonLangValue(data["custom_field_name"]) }}
      </v-sheet>
      <v-textarea
        rows="5"
        no-resize
        maxlength="500"
        :readonly="!iSEdited"
        :placeholder="$getCommonLangValue(data['custom_field_placeholder'])"
        :filled="iSEdited"
        dense
        counter="500"
        single-line
        :rules="
          Number(data.is_required) ? $GetRules(['_Require_Rules'], [null]) : []
        "
        v-model="curvalue"
        name="input-7-4"
      ></v-textarea>
    </template>
    <normalInputTextFiled
      v-else-if="data && data['custom_field_data_type'] == 'string'"
      maxlength="100"
      :readonly="!iSEdited"
      :filled="iSEdited"
      :placeholder="$getCommonLangValue(data['custom_field_placeholder'])"
      :label="$getCommonLangValue(data['custom_field_name'])"
      :rules="
        Number(data.is_required) ? $GetRules(['_Require_Rules'], [null]) : []
      "
      v-model="curvalue"
    />
    <normalInputTextFiled
      v-else-if="data && data['custom_field_data_type'] == 'double'"
      maxlength="100"
      :placeholder="$getCommonLangValue(data['custom_field_placeholder'])"
      type="number"
      :readonly="!iSEdited"
      :filled="iSEdited"
      :label="$getCommonLangValue(data['custom_field_name'])"
      :rules="
        Number(data.is_required) ? $GetRules(['_Require_Rules'], [null]) : []
      "
      v-model="curvalue"
    />
    <normalInputTextFiled
      v-else-if="data && data['custom_field_data_type'] == 'float'"
      maxlength="100"
      :readonly="!iSEdited"
      :filled="iSEdited"
      :placeholder="$getCommonLangValue(data['custom_field_placeholder'])"
      type="number"
      :label="$getCommonLangValue(data['custom_field_name'])"
      :rules="
        Number(data.is_required) ? $GetRules(['_Require_Rules'], [null]) : []
      "
      v-model="curvalue"
    />
    <numberInputTextFiled
      v-else-if="data && data['custom_field_data_type'] == 'int'"
      maxlength="11"
      :readonly="!iSEdited"
      :filled="iSEdited"
      :placeholder="$getCommonLangValue(data['custom_field_placeholder'])"
      :rules="$GetRules(['_Number_negative', '_Length_Rules'], [null, 11])"
      v-model="curvalue"
      :label="$getCommonLangValue(data['custom_field_name'])"
      isNotRequire
    />
    <DateTimePicker
      v-else-if="data && data['custom_field_data_type'] == 'datetime'"
      :rules="
        Number(data.is_required) ? $GetRules(['_Require_Rules'], [null]) : []
      "
      type="datetime"
      :defaultTime="curvalue"
      :readonly="!iSEdited"
      :filled="iSEdited"
      :label="$getCommonLangValue(data['custom_field_name'])"
      :placeholder="$getCommonLangValue(data['custom_field_placeholder'])"
      @change="
        (time) => {
          curvalue = time;
        }
      "
    />
    <DateTimePicker
      v-else-if="data && data['custom_field_data_type'] == 'date'"
      :rules="
        Number(data.is_required) ? $GetRules(['_Require_Rules'], [null]) : []
      "
      type="date"
      :defaultTime="curvalue"
      :readonly="!iSEdited"
      :filled="iSEdited"
      :label="$getCommonLangValue(data['custom_field_name'])"
      :placeholder="$getCommonLangValue(data['custom_field_placeholder'])"
      @change="
        (time) => {
          curvalue = time;
        }
      "
    />
    <TimePicker
      v-else-if="data && data['custom_field_data_type'] == 'time'"
      isRequire
      :disable="!iSEdited"
      :value="curvalue"
      :defaultTime="curvalue"
      :placeholder="$getCommonLangValue(data['custom_field_placeholder'])"
      :label="$getCommonLangValue(data['custom_field_name'])"
      @change="
        (time) => {
          curvalue = time;
        }
      "
    />
    <DateTimePicker
      v-else-if="data && data['custom_field_data_type'] == 'month'"
      :rules="
        Number(data.is_required) ? $GetRules(['_Require_Rules'], [null]) : []
      "
      type="month"
      :readonly="!iSEdited"
      :filled="iSEdited"
      :defaultTime="curvalue"
      :label="$getCommonLangValue(data['custom_field_name'])"
      :placeholder="$getCommonLangValue(data['custom_field_placeholder'])"
      @change="
        (time) => {
          curvalue = time;
        }
      "
    />
    <BooleanRadioField
      :disabled="!iSEdited"
      v-model="curvalue"
      v-else-if="data && data['custom_field_data_type'] == 'boolean'"
      :isRequire="Number(data.is_required)"
      :label="$getCommonLangValue(data['custom_field_name'])"
      @click="
        (boolean) => {
          curvalue = boolean;
        }
      "
    />
    <MicrosoftFileDragUpdate
      v-else-if="data && data['custom_field_data_type'] == 'file'"
      :label="$getCommonLangValue(data['custom_field_name'])"
      :disabled="!iSEdited"
      :validate="validate"
      :isRequire="Number(data['is_required'])"
      :defaultImageList="fileList"
      @error="
        (val) => {
          $emit('error', val);
        }
      "
      @change="
        (val) => {
          curvalue = val;
        }
      "
    />
    <!-- <MicrosoftFileDragUpdate
      v-else-if="data && data['custom_field_data_type'] == 'file'"
      isSingle
      @change="
        (val) => {
          curvalue = val;
        }
      "
    /> -->
    <!-- <DateTimePicker
      v-else-if="data && data['custom_field_data_type'] == 'year'"
      :rules="
        Number(data.is_required) ? $GetRules(['_Require_Rules'], [null]) : []
      "
      type="year"
      :defaultTime="curvalue"
      :filled="iSEdited"
      :label="$getCommonLangValue(data['custom_field_name'])"
      :placeholder="$getCommonLangValue(data['custom_field_placeholder'])"
      @change="
        (time) => {
          curvalue = time;
        }
      "
    /> -->

    <!-- 暂无此类型 -->
    <normalInputTextFiled
      v-else
      maxlength="100"
      :readonly="!iSEdited"
      :filled="iSEdited"
      :placeholder="$getCommonLangValue(data['custom_field_placeholder'])"
      :label="$getCommonLangValue(data['custom_field_name'])"
      :rules="
        Number(data.is_required) ? $GetRules(['_Require_Rules'], [null]) : []
      "
      v-model="curvalue"
    />
  </v-col>
</template>
<script>
export default {
  name: "DynamicForm",
  props: {
    data: { default: null, type: [Object, Array, String] },
    iSEdited: { default: true, type: [Number, Boolean] },
    validate: { default: false, type: [Number, Boolean] },
  },
  computed: {
    formStyle() {
      let style = { xs: 12, sm: 12, md: 6, lg: 6, xl: 4, cols: 12 };
      let layout = this.$iSJson(this.data["custom_field_data_layout"]);
      if (layout) {
        style = {
          xs: layout?.xs ?? 12,
          sm: layout?.sm ?? 12,
          md: layout?.md ?? 6,
          lg: layout?.lg ?? 6,
          xl: layout?.xl ?? 4,
          cols: layout?.cols ?? 12,
        };
        return style;
      } else return style;
    },
  },
  created() {
    const that = this;

    if (
      this.data["_value_init"] === "" &&
      (this.data["custom_field_data_type"] == "string" ||
        this.data["custom_field_data_type"] == "text")
    ) {
      this.curvalue = this.data["_value_init"] ? this.data["_value_init"] : "";
    } else if (this.data["custom_field_data_type"] == "date")
      this.curvalue = this.data["_value_init"];
    else if (this.data["custom_field_data_type"] == "datetime")
      this.curvalue = this.data["_value_init"];
    else if (this.data["custom_field_data_type"] == "month")
      this.curvalue = this.data["_value_init"];
    else if (this.data["custom_field_data_type"] == "time")
      this.curvalue = this.data["_value_init"];
    else if (this.data["custom_field_data_type"] == "file") {
      if (this.data["_value_init"] && this.data["_value_init"].length) {
        this.curvalue = [];
        this.data["_value_init"].map((item) => {
          item["uuid"] = item["uuid"];
          item["file_name"] = item["file_name"];
          item["path"] = item["url"];
          item["save"] = true; //保留线上
          item["size"] = item["attachment_size"];
          that.curvalue.push(item["uuid"]);
        });
        this.fileList = this.data["_value_init"];
      } else {
        this.curvalue = [];
      }
    } else this.curvalue = this.data["_value_init"];
  },
  watch: {
    curvalue(val) {
      const that = this;
      if (typeof val === "string") val = val.replace(/(^\s*)|(\s*$)/g, ""); //去掉左右空格
      let change = this.$isEqualInitValue(
        this.data["custom_field_data_type"],
        val,
        this.data["_value_init"]
      );
      this.$emit(
        "change",
        this.data["uuid"] ? this.data["uuid"] : null,
        val,
        change
      );
    },
  },
  data() {
    return {
      curvalue: "",
      fileList: [],
      booleanFalse: 1,
      booleanTrue: 0,
    };
  },
  methods: {},
};
</script>